import moment from 'moment';
import store from '@/store/store';
import { COULEUR_PANNEAU_DEFAUT } from '@/configurations/configPanneau';

moment.locale('fr');

export function formatDate(date) {
  return moment(date).format('L');
}

export function formatDateBack(date) {
  return moment(date).format('YYYY-MM-DD');
}

export function getImg(img) {
  if (img === null || img === '') return require('@/assets/images/default_img.png');
  return img;
}
export function formatNombre(nombre) {
  const val = nombre || 0;
  return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(val);
}

export function arrondiResult(value) {
  let newValue = value;
  if (newValue) {
    newValue = Math.round(newValue * 100) / 100;
  }
  return newValue;
}

export function getCouleurCategorie(produit) {
  return produit?.couleurHtmlRgb || COULEUR_PANNEAU_DEFAUT;
}

export function getImgPanneau(img) {
  if (img === undefined || img === null || img === '') return require('@/assets/images/default_img.png');
  return img;
}
export function getImgAltPanneau(img) {
  if (img === null || img === '') return require('@/assets/images/default_img.png');
  return img;
}

export function getDep(codePostal) {
  const departements = store.getters['dataTiers/departements'];
  const data = departements.filter(dep => {
    const regex = new RegExp(`^${dep.label}`);
    return regex.test(codePostal);
  });
  return data.length ? data[0].label : '';
}

export function getIdHash(hash) {
  return atob(hash).split('|')[0];
}

export function toFormData(data) {
  const formdata = new FormData();
  Object.keys(data).forEach(key => {
    formdata.append(key, data[key]);
  });
  return formdata;
}

export function adressFullStringGetter(adresse) {
  if (!adresse) {
    return '';
  }
  let adresseString = '';
  if (adresse.adresse1 !== null && adresse.adresse1) {
    adresseString += ' ' + adresse.adresse1;
  }
  if (adresse.adresse2 !== null && adresse.adresse2) {
    adresseString += ' ' + adresse.adresse2;
  }
  if (adresse.adresse3 !== null && adresse.adresse3) {
    adresseString += ' ' + adresse.adresse3;
  }
  if (adresseString.length > 0) {
    adresseString += ',';
  }
  if (adresse.codePostal !== null && adresse.codePostal) {
    adresseString += ' ' + adresse.codePostal;
  }
  if (adresse.ville !== null && adresse.ville) {
    adresseString += ' ' + adresse.ville;
  }
  return adresseString.trim();
}
